function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import Constants from "segments/desktop/grid/layouts/blog-cards-grid/constants";
import { StyledBlogCardsGridComponent } from "./blog-cards-grid-component.scss";
import BlogCardItemComponent from "./blog-card-item/blog-card-item-component";
class BlogCardsGridComponent extends PureComponent {
    renderBlogCards() {
        const { gridItems, hideFooter, buttonConfig, imageMaxHeight } = this.props;
        return gridItems.map((gridItem, index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "blog-card-item-component-wrapper",
                children: /*#__PURE__*/ _jsx(BlogCardItemComponent, _object_spread_props(_object_spread({}, gridItem), {
                    hideFooter: hideFooter,
                    buttonConfig: buttonConfig,
                    imageMaxHeight: imageMaxHeight
                }))
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledBlogCardsGridComponent, {
            className: "blog-cards-grid-component",
            children: this.renderBlogCards()
        });
    }
}
export { BlogCardsGridComponent as default };
BlogCardsGridComponent.defaultProps = {
    hideFooter: false,
    gridItems: [
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/painted-people.png"
            },
            title: "New Feature Updates: Check Out Our New Zoom Integration!",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "3 min read"
            }
        },
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/monday-zoom-integration.png"
            },
            title: "6 reasons why distributed teams are the future of work",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "8 min read"
            }
        },
        {
            image: {
                src: "/static/img/segment-layout-default-images/grid/persoon-with-mountain-view.png"
            },
            title: "How Kim Garst rapidly scaled her business",
            footer: {
                writerImageSrc: "/static/img/segment-layout-default-images/grid/article-writer-woman.png",
                writerName: "Eliana Atia",
                articleDate: "Mar 12,2020",
                minutesToRead: "16 min read"
            }
        }
    ],
    paddingTop: 64,
    paddingBottom: 64,
    buttonConfig: {
        buttonType: null
    },
    imageMaxHeight: Constants.IMAGE_HEIGHT
};
